import { ILaya } from "../../ILaya";
import { Const } from "../Const";
import { RenderManager2D } from "../NodeRender2D/RenderManager2D";
import { RenderState } from "../RenderDriver/RenderModuleData/Design/RenderState";
import { TextureFormat } from "../RenderEngine/RenderEnum/TextureFormat";
import { Shader3D } from "../RenderEngine/RenderShader/Shader3D";
import { Bezier } from "../maths/Bezier";
import { Color } from "../maths/Color";
import { Matrix } from "../maths/Matrix";
import { Matrix4x4 } from "../maths/Matrix4x4";
import { Rectangle } from "../maths/Rectangle";
import { Vector2 } from "../maths/Vector2";
import { Vector4 } from "../maths/Vector4";
import { Texture } from "../resource/Texture";
import { Texture2D } from "../resource/Texture2D";
import { BlendMode } from "../webgl/canvas/BlendMode";
import { DrawStyle } from "../webgl/canvas/DrawStyle";
import { Path } from "../webgl/canvas/Path";
import { SaveBase } from "../webgl/canvas/save/SaveBase";
import { SaveClipRect } from "../webgl/canvas/save/SaveClipRect";
import { SaveMark } from "../webgl/canvas/save/SaveMark";
import { SaveTransform } from "../webgl/canvas/save/SaveTransform";
import { SaveTranslate } from "../webgl/canvas/save/SaveTranslate";
import { Shader2D } from "../webgl/shader/d2/Shader2D";
import { ShaderDefines2D } from "../webgl/shader/d2/ShaderDefines2D";
import { RenderSpriteData, Value2D } from "../webgl/shader/d2/value/Value2D";
import { BasePoly } from "../webgl/shapes/BasePoly";
import { Earcut } from "../webgl/shapes/Earcut";
import { SubmitBase } from "../webgl/submit/SubmitBase";
import { SubmitKey } from "../webgl/submit/SubmitKey";
import { CharSubmitCache } from "../webgl/text/CharSubmitCache";
import { MeasureFont } from "../webgl/text/MeasureFont";
import { TextRender } from "../webgl/text/TextRender";
import { MeshQuadTexture } from "../webgl/utils/MeshQuadTexture";
import { MeshTexture } from "../webgl/utils/MeshTexture";
import { MeshVG } from "../webgl/utils/MeshVG";
import { RenderState2D } from "../webgl/utils/RenderState2D";
import { Render2DSimple } from "./Render2D";
const defaultClipMatrix = new Matrix(Const.MAX_CLIP_SIZE, 0, 0, Const.MAX_CLIP_SIZE, 0, 0);
const tmpuv1 = [0, 0, 0, 0, 0, 0, 0, 0];
const tmpMat = new Matrix();
var _clipResult = new Vector2();
export class Context {
    static __init__() {
        Context.MAXCLIPRECT = new Rectangle(0, 0, Const.MAX_CLIP_SIZE, Const.MAX_CLIP_SIZE);
        ContextParams.DEFAULT = new ContextParams();
        if (!Context._textRender) {
            let textRender = Context._textRender = new TextRender();
            textRender.fontMeasure = new MeasureFont(textRender.charRender);
        }
    }
    constructor() {
        this._alpha = 1.0;
        this._material = null;
        this._fillStyle = DrawStyle.DEFAULT;
        this._strokeStyle = DrawStyle.DEFAULT;
        this._drawTexToDrawTri_Vert = new Float32Array(8);
        this._drawTexToDrawTri_Index = new Uint16Array([0, 1, 2, 0, 2, 3]);
        this._tempUV = new Float32Array(8);
        this._drawTriUseAbsMatrix = false;
        this._other = null;
        this._path = null;
        this._drawCount = 1;
        this._width = Const.MAX_CLIP_SIZE;
        this._height = Const.MAX_CLIP_SIZE;
        this._renderCount = 0;
        this.stopMerge = true;
        this._curSubmit = SubmitBase.RENDERBASE;
        this._submitKey = new SubmitKey();
        this._meshQuatTex = new MeshQuadTexture();
        this._meshVG = new MeshVG();
        this._meshTex = new MeshTexture();
        this._transedPoints = new Array(8);
        this._temp4Points = new Array(8);
        this._clipRect = Context.MAXCLIPRECT;
        this._globalClipMatrix = defaultClipMatrix.clone();
        this._clipInfoID = 0;
        this._clipID_Gen = 0;
        this._matBuffer = new Float32Array(6);
        this._lastMatScaleX = 1.0;
        this._lastMatScaleY = 1.0;
        this._lastMat_a = 1.0;
        this._lastMat_b = 0.0;
        this._lastMat_c = 0.0;
        this._lastMat_d = 1.0;
        this._nBlendType = 0;
        this._save = null;
        this._charSubmitCache = null;
        this._saveMark = null;
        this._shader2D = new Shader2D();
        this.sprite = null;
        this._italicDeg = 0;
        this._lastTex = null;
        this._fillColor = 0;
        this._flushCnt = 0;
        this.defTexture = null;
        this._colorFiler = null;
        this.drawTexAlign = false;
        this._incache = false;
        this._isMain = false;
        this._render2D = null;
        this._clearColor = new Color(0, 0, 0, 0);
        this._clear = false;
        this._shaderValueNeedRelease = [];
        this.render2D = new Render2DSimple();
        Context._contextcount++;
        if (!this.defTexture) {
            var defTex2d = new Texture2D(2, 2, TextureFormat.R8G8B8A8, true, false, false);
            defTex2d.setPixelsData(new Uint8Array(16), false, false);
            defTex2d.lock = true;
            this.defTexture = new Texture(defTex2d);
        }
        this._lastTex = this.defTexture;
        this._other = ContextParams.DEFAULT;
        this._curMat = Matrix.create();
        this._charSubmitCache = new CharSubmitCache(this);
        this._mesh = this._meshQuatTex;
        this._mesh.clearMesh();
        this._save = [SaveMark.Create(this)];
        this._save.length = 10;
        this.clear();
        this._render2DManager = new RenderManager2D();
    }
    copyState(ctx) {
    }
    set isMain(v) {
        this._isMain = v;
        if (v) {
        }
    }
    get isMain() {
        return this._isMain;
    }
    set render2D(render) {
        this._render2D = render;
    }
    get render2D() {
        return this._render2D;
    }
    get lineJoin() {
        return '';
    }
    set lineJoin(value) {
    }
    get lineCap() {
        return '';
    }
    set lineCap(value) {
    }
    get miterLimit() {
        return '';
    }
    set miterLimit(value) {
    }
    touchRes(res) {
        res.touch();
    }
    transformByMatrix(matrix, tx, ty) {
        this.transform(matrix.a, matrix.b, matrix.c, matrix.d, matrix.tx + tx, matrix.ty + ty);
    }
    drawRect(x, y, width, height, fillColor, lineColor, lineWidth) {
        var ctx = this;
        if (fillColor != null) {
            ctx.fillStyle = fillColor;
            ctx.fillRect(x, y, width, height);
        }
        if (lineColor != null) {
            ctx.strokeStyle = lineColor;
            ctx.lineWidth = lineWidth;
            ctx.strokeRect(x, y, width, height);
        }
    }
    alpha(value) {
        this.globalAlpha *= value;
    }
    _transform(mat, pivotX, pivotY) {
        this.translate(pivotX, pivotY);
        this.transform(mat.a, mat.b, mat.c, mat.d, mat.tx, mat.ty);
        this.translate(-pivotX, -pivotY);
    }
    _rotate(angle, pivotX, pivotY) {
        this.translate(pivotX, pivotY);
        this.rotate(angle);
        this.translate(-pivotX, -pivotY);
    }
    _scale(scaleX, scaleY, pivotX, pivotY) {
        this.translate(pivotX, pivotY);
        this.scale(scaleX, scaleY);
        this.translate(-pivotX, -pivotY);
    }
    _drawLine(x, y, fromX, fromY, toX, toY, lineColor, lineWidth, vid) {
        this.beginPath();
        this.strokeStyle = lineColor;
        this.lineWidth = lineWidth;
        this.moveTo(x + fromX, y + fromY);
        this.lineTo(x + toX, y + toY);
        this.stroke();
    }
    _drawLines(x, y, points, lineColor, lineWidth, vid) {
        this.beginPath();
        this.strokeStyle = lineColor;
        this.lineWidth = lineWidth;
        this.addPath(points.slice(), false, false, x, y);
        this.stroke();
    }
    drawCurves(x, y, points, lineColor, lineWidth) {
        this.beginPath();
        this.strokeStyle = lineColor;
        this.lineWidth = lineWidth;
        this.moveTo(x + points[0], y + points[1]);
        var i = 2, n = points.length;
        while (i < n) {
            this.quadraticCurveTo(x + points[i++], y + points[i++], x + points[i++], y + points[i++]);
        }
        this.stroke();
    }
    _fillAndStroke(fillColor, strokeColor, lineWidth, isConvexPolygon = false) {
        if (fillColor != null) {
            this.fillStyle = fillColor;
            this.fill();
        }
        if (strokeColor != null && lineWidth > 0) {
            this.strokeStyle = strokeColor;
            this.lineWidth = lineWidth;
            this.stroke();
        }
    }
    _drawCircle(x, y, radius, fillColor, lineColor, lineWidth, vid) {
        this.beginPath(true);
        this.arc(x, y, radius, radius, 0, 2 * Math.PI, false, true, 40);
        this.closePath();
        this._fillAndStroke(fillColor, lineColor, lineWidth);
    }
    _drawEllipse(x, y, width, height, fillColor, lineColor, lineWidth) {
        this.beginPath(true);
        this.arc(x, y, width, height, 0, 2 * Math.PI, false, true, 40);
        this.closePath();
        this._fillAndStroke(fillColor, lineColor, lineWidth);
    }
    _drawRoundRect(x, y, width, height, lt, rt, lb, rb, fillColor, lineColor, lineWidth) {
        if (width <= 0)
            return;
        if (height <= 0)
            return;
        this.beginPath(true);
        var tPath = this._getPath();
        if (0 >= lt) {
            tPath.addPoint(x, y);
        }
        else {
            let st = Math.PI;
            let ed = 1.5 * Math.PI;
            if (width < lt + rt) {
                let dxlt = lt * (lt + rt - width) / (lt + rt);
                let hity = Math.sqrt(lt * lt - dxlt * dxlt);
                let ang = Math.atan2(hity, dxlt);
                let dAng = 0.5 * Math.PI - ang;
                ed -= dAng;
            }
            if (height < lt + lb) {
                let dylt = lt * (lt + lb - height) / (lt + lb);
                let hitx = Math.sqrt(lt * lt - dylt * dylt);
                let ang = Math.atan2(dylt, hitx);
                st += ang;
            }
            if (st > ed) {
            }
            else {
                this.arc(x + lt, y + lt, lt, lt, st, ed, false, true, 5);
            }
        }
        let startX = x + width - rt;
        if (0 >= rt) {
            tPath.addPoint(startX, y);
        }
        else {
            let st = 1.5 * Math.PI;
            let ed = 2 * Math.PI;
            if (width < lt + rt) {
                let dxlt = rt * (lt + rt - width) / (lt + rt);
                let hity = Math.sqrt(lt * lt - dxlt * dxlt);
                let ang = Math.atan2(hity, dxlt);
                let dAng = 0.5 * Math.PI - ang;
                st += dAng;
            }
            if (height < rt + rb) {
                let dyrt = rt * (rt + rb - height) / (rt + rb);
                let hitx = Math.sqrt(rt * rt - dyrt * dyrt);
                let ang = Math.atan2(dyrt, hitx);
                ed -= ang;
            }
            if (st > ed) {
            }
            else {
                this.arc(startX, y + rt, rt, rt, st, ed, false, true, 5);
            }
        }
        startX = x + width - rb;
        let startY = y + height - rb;
        if (0 >= rb) {
            tPath.addPoint(startX, startY);
        }
        else {
            let st = 0;
            let ed = 0.5 * Math.PI;
            if (width < lb + rb) {
                let dxlb = rb * (lb + rb - width) / (lb + rb);
                let hity = Math.sqrt(lb * lb - dxlb * dxlb);
                let ang = Math.atan2(hity, dxlb);
                let dAng = 0.5 * Math.PI - ang;
                ed -= dAng;
            }
            if (height < rt + rb) {
                let dyrt = rb * (rt + rb - height) / (rt + rb);
                let hitx = Math.sqrt(rb * rb - dyrt * dyrt);
                let ang = Math.atan2(dyrt, hitx);
                st += ang;
            }
            if (st > ed) {
            }
            else {
                this.arc(startX, startY, rb, rb, st, ed, false, true, 5);
            }
        }
        startX = x + lb;
        startY = y + height - lb;
        if (0 >= lb) {
            tPath.addPoint(startX, startY);
        }
        else {
            let st = 0.5 * Math.PI;
            let ed = Math.PI;
            if (width < lb + rb) {
                let dxlb = rb * (lb + rb - width) / (lb + rb);
                let hity = Math.sqrt(lb * lb - dxlb * dxlb);
                let ang = Math.atan2(hity, dxlb);
                let dAng = 0.5 * Math.PI - ang;
                st += dAng;
            }
            if (height < lt + lb) {
                let dylt = lb * (lt + lb - height) / (lt + lb);
                let hitx = Math.sqrt(lb * lb - dylt * dylt);
                let ang = Math.atan2(dylt, hitx);
                ed -= ang;
            }
            if (st > ed) {
            }
            else {
                this.arc(startX, startY, lb, lb, st, ed, false, true, 5);
            }
        }
        this.closePath();
        this._fillAndStroke(fillColor, lineColor, lineWidth);
    }
    _drawPie(x, y, radius, startAngle, endAngle, fillColor, lineColor, lineWidth, vid) {
        this.beginPath();
        this.moveTo(x, y);
        this.arc(x, y, radius, radius, startAngle, endAngle);
        this.closePath();
        this._fillAndStroke(fillColor, lineColor, lineWidth);
    }
    _drawPoly(x, y, points, fillColor, lineColor, lineWidth, isConvexPolygon, vid) {
        this.beginPath();
        this.addPath(points.slice(), true, isConvexPolygon, x, y);
        this.closePath();
        this._fillAndStroke(fillColor, lineColor, lineWidth, isConvexPolygon);
    }
    _drawPath(x, y, paths, brush, pen) {
        this.beginPath();
        for (var i = 0, n = paths.length; i < n; i++) {
            var path = paths[i];
            switch (path[0]) {
                case "moveTo":
                    this.moveTo(x + path[1], y + path[2]);
                    break;
                case "lineTo":
                    this.lineTo(x + path[1], y + path[2]);
                    break;
                case "arcTo":
                    this.arcTo(x + path[1], y + path[2], x + path[3], y + path[4], path[5]);
                    break;
                case "closePath":
                    this.closePath();
                    break;
            }
        }
        if (brush != null) {
            this.fillStyle = brush.fillStyle;
            this.fill();
        }
        if (pen != null) {
            this.strokeStyle = pen.strokeStyle;
            this.lineWidth = pen.lineWidth || 1;
            this.lineJoin = pen.lineJoin;
            this.lineCap = pen.lineCap;
            this.miterLimit = pen.miterLimit;
            this.stroke();
        }
    }
    static set2DRenderConfig() {
    }
    clearBG(r, g, b, a) {
        if (r == null || r == undefined) {
            this._clear = false;
        }
        else {
            this._clearColor.setValue(r, g, b, a);
            this._clear = true;
        }
    }
    _releaseMem() {
        this._curMat && this._curMat.destroy();
        this._curMat = null;
        this._shader2D.destroy();
        this._shader2D = null;
        this._charSubmitCache.clear();
        this._path = null;
        this._save = null;
        this.sprite = null;
    }
    destroy() {
        --Context._contextcount;
        this.sprite = null;
        this._charSubmitCache && this._charSubmitCache.destroy();
        if (this.defTexture) {
            this.defTexture.bitmap && this.defTexture.bitmap.destroy();
            this.defTexture.destroy();
        }
        for (var i = 0, n = this._shaderValueNeedRelease.length; i < n; i++) {
            this._shaderValueNeedRelease[i] && this._shaderValueNeedRelease[i].release();
        }
    }
    clear() {
        this._submitKey.clear();
        this._drawCount = 1;
        this._other = ContextParams.DEFAULT;
        this._alpha = 1.0;
        this._nBlendType = 0;
        this._clipRect = Context.MAXCLIPRECT;
        this._fillStyle = this._strokeStyle = DrawStyle.DEFAULT;
        this._curMat.identity();
        this._other.clear();
        this._saveMark = this._save[0];
        this._save._length = 1;
    }
    size(w, h) {
        if (this._width != w || this._height != h) {
            this._width = w;
            this._height = h;
            if (this.isMain) {
                RenderState2D.width = w;
                RenderState2D.height = h;
            }
        }
        if (w === 0 && h === 0)
            this._releaseMem();
    }
    get width() {
        return this._width;
    }
    set width(w) {
        this.size(w, this._height);
    }
    get height() {
        return this._height;
    }
    set height(h) {
        this.size(this._width, h);
    }
    getMatScaleX() {
        if (this._lastMat_a == this._curMat.a && this._lastMat_b == this._curMat.b)
            return this._lastMatScaleX;
        this._lastMatScaleX = this._curMat.getScaleX();
        this._lastMat_a = this._curMat.a;
        this._lastMat_b = this._curMat.b;
        return this._lastMatScaleX;
    }
    getMatScaleY() {
        if (this._lastMat_c == this._curMat.c && this._lastMat_d == this._curMat.d)
            return this._lastMatScaleY;
        this._lastMatScaleY = this._curMat.getScaleY();
        this._lastMat_c = this._curMat.c;
        this._lastMat_d = this._curMat.d;
        return this._lastMatScaleY;
    }
    getFillColor() {
        return this._fillColor;
    }
    set fillStyle(value) {
        if (!this._fillStyle.equal(value)) {
            SaveBase.save(this, SaveBase.TYPE_FILESTYLE, this._shader2D, false);
            this._fillStyle = DrawStyle.create(value);
            this._submitKey.other = -this._fillStyle._color.numColor;
        }
    }
    get fillStyle() {
        return this._fillStyle;
    }
    set globalAlpha(value) {
        value = Math.floor(value * 1000) / 1000;
        if (value != this._alpha) {
            SaveBase.save(this, SaveBase.TYPE_ALPHA, this._shader2D, false);
            this._alpha = value;
        }
    }
    get globalAlpha() {
        return this._alpha;
    }
    set textAlign(value) {
        (this._other.textAlign === value) || (this._other = this._other.make(), SaveBase.save(this, SaveBase.TYPE_TEXTALIGN, this._other, false), this._other.textAlign = value);
    }
    get textAlign() {
        return this._other.textAlign;
    }
    set textBaseline(value) {
        (this._other.textBaseline === value) || (this._other = this._other.make(), SaveBase.save(this, SaveBase.TYPE_TEXTBASELINE, this._other, false), this._other.textBaseline = value);
    }
    get textBaseline() {
        return this._other.textBaseline;
    }
    set globalCompositeOperation(value) {
        this._drawToRender2D(this._curSubmit);
        var n = BlendMode.TOINT[value];
        n == null || (this._nBlendType === n) || (SaveBase.save(this, SaveBase.TYPE_GLOBALCOMPOSITEOPERATION, this, true), this._curSubmit = SubmitBase.RENDERBASE, this._nBlendType = n);
    }
    get globalCompositeOperation() {
        return BlendMode.NAMES[this._nBlendType];
    }
    set strokeStyle(value) {
        this._strokeStyle.equal(value) || (SaveBase.save(this, SaveBase.TYPE_STROKESTYLE, this._shader2D, false), this._strokeStyle = DrawStyle.create(value), this._submitKey.other = -this._strokeStyle._color.numColor);
    }
    get strokeStyle() {
        return this._strokeStyle;
    }
    translate(x, y) {
        if (x !== 0 || y !== 0) {
            SaveTranslate.save(this);
            if (this._curMat._bTransform) {
                SaveTransform.save(this);
                this._curMat.tx += (x * this._curMat.a + y * this._curMat.c);
                this._curMat.ty += (x * this._curMat.b + y * this._curMat.d);
            }
            else {
                this._curMat.tx = x;
                this._curMat.ty = y;
            }
        }
    }
    set lineWidth(value) {
        (this._other.lineWidth === value) || (this._other = this._other.make(), SaveBase.save(this, SaveBase.TYPE_LINEWIDTH, this._other, false), this._other.lineWidth = value);
    }
    get lineWidth() {
        return this._other.lineWidth;
    }
    save() {
        this._save[this._save._length++] = SaveMark.Create(this);
    }
    restore() {
        var sz = this._save._length;
        var lastBlend = this._nBlendType;
        if (sz < 1)
            return;
        for (var i = sz - 1; i >= 0; i--) {
            var o = this._save[i];
            o.restore(this);
            if (o.isSaveMark()) {
                this._save._length = i;
                return;
            }
        }
        if (lastBlend != this._nBlendType) {
            this.stopMerge = true;
        }
    }
    fillText(txt, x, y, fontStr, color, align, lineWidth = 0, borderColor = "") {
        Context._textRender.filltext(this, txt, x, y, fontStr, color, borderColor, lineWidth, align);
    }
    drawText(text, x, y, font, color, textAlign) {
        Context._textRender.filltext(this, text, x, y, font, color, null, 0, textAlign);
    }
    strokeWord(text, x, y, font, color, lineWidth, textAlign) {
        Context._textRender.filltext(this, text, x, y, font, null, color, lineWidth, textAlign);
    }
    fillBorderText(txt, x, y, font, color, borderColor, lineWidth, textAlign) {
        Context._textRender.filltext(this, txt, x, y, font, color, borderColor, lineWidth, textAlign);
    }
    _fast_filltext(data, x, y, fontObj, color, strokeColor, lineWidth, textAlign) {
        Context._textRender._fast_filltext(this, data, x, y, fontObj, color, strokeColor, lineWidth, textAlign);
    }
    _fillRect(x, y, width, height, rgba) {
        var submit = this._curSubmit;
        var sameKey = this._mesh.vertexNum + 4 < Context._MAXVERTNUM &&
            submit && (submit._key.submitType === SubmitBase.KEY_DRAWTEXTURE &&
            submit._key.blendShader === this._nBlendType &&
            !this.isStopMerge(submit)) &&
            this._curSubmit.material == this._material;
        if (!sameKey) {
            this._drawToRender2D(this._curSubmit);
            this._mesh = this._meshQuatTex;
        }
        let mesh = this._mesh;
        this.transformQuad(x, y, width, height, 0, this._curMat, this._transedPoints);
        if (!this.clipedOff(this._transedPoints)) {
            if (!sameKey) {
                submit = this._curSubmit = SubmitBase.create(this, mesh, Value2D.create(RenderSpriteData.Texture2D));
                this.fillShaderValue(submit.shaderValue);
                this._copyClipInfo(submit.shaderValue);
                submit.clipInfoID = this._clipInfoID;
                if (!this._lastTex || this._lastTex.destroyed) {
                    submit.shaderValue.textureHost = this.defTexture;
                }
                else {
                    submit.shaderValue.textureHost = this._lastTex;
                }
                submit._key.other = (this._lastTex && this._lastTex.bitmap) ? this._lastTex.bitmap.id : -1;
            }
            mesh.addQuad(this._transedPoints, Texture.NO_UV, rgba, false);
            this._curSubmit._numEle += 6;
        }
    }
    fillRect(x, y, width, height, fillStyle) {
        var drawstyle = fillStyle ? DrawStyle.create(fillStyle) : this._fillStyle;
        var rgba = this.mixRGBandAlpha(drawstyle._color.numColor);
        this._fillRect(x, y, width, height, rgba);
    }
    fillTexture(texture, x, y, width, height, type, offset, color) {
        if (!texture._getSource()) {
            this.sprite && ILaya.systemTimer.callLater(this, this._repaintSprite);
            return;
        }
        this._fillTexture(texture, texture.width, texture.height, texture.uvrect, x, y, width, height, type, offset.x, offset.y, color);
    }
    _fillTexture(texture, texw, texh, texuvRect, x, y, width, height, type, offsetx, offsety, color) {
        var submit = this._curSubmit;
        this._drawToRender2D(this._curSubmit);
        this._mesh = this._meshQuatTex;
        var repeatx = true;
        var repeaty = true;
        switch (type) {
            case "repeat": break;
            case "repeat-x":
                repeaty = false;
                break;
            case "repeat-y":
                repeatx = false;
                break;
            case "no-repeat":
                repeatx = repeaty = false;
                break;
            default: break;
        }
        var uv = this._temp4Points;
        var stu = 0;
        var stv = 0;
        var stx = 0, sty = 0, edx = 0, edy = 0;
        if (offsetx < 0) {
            stx = x;
            stu = (-offsetx % texw) / texw;
        }
        else {
            stx = x + offsetx;
        }
        if (offsety < 0) {
            sty = y;
            stv = (-offsety % texh) / texh;
        }
        else {
            sty = y + offsety;
        }
        edx = x + width;
        edy = y + height;
        (!repeatx) && (edx = Math.min(edx, x + offsetx + texw));
        (!repeaty) && (edy = Math.min(edy, y + offsety + texh));
        if (edx < x || edy < y)
            return;
        if (stx > edx || sty > edy)
            return;
        var edu = (edx - x - offsetx) / texw;
        var edv = (edy - y - offsety) / texh;
        this.transformQuad(stx, sty, edx - stx, edy - sty, 0, this._curMat, this._transedPoints);
        uv[0] = stu;
        uv[1] = stv;
        uv[2] = edu;
        uv[3] = stv;
        uv[4] = edu;
        uv[5] = edv;
        uv[6] = stu;
        uv[7] = edv;
        if (!this.clipedOff(this._transedPoints)) {
            var sv = Value2D.create(RenderSpriteData.Texture2D);
            sv.shaderData.addDefine(ShaderDefines2D.FILLTEXTURE);
            var arry = texuvRect.concat();
            Vector4.TEMP.setValue(arry[0], arry[1], arry[2], arry[3]);
            sv.u_TexRange = Vector4.TEMP;
            submit = this._curSubmit = SubmitBase.create(this, this._mesh, sv);
            this.fillShaderValue(sv);
            submit.clipInfoID = this._clipInfoID;
            submit.shaderValue.textureHost = texture;
            var rgba = this._mixRGBandAlpha(color, this._alpha);
            this._mesh.addQuad(this._transedPoints, uv, rgba, true);
            this._curSubmit._numEle += 6;
        }
        this.breakNextMerge();
    }
    setColorFilter(filter) {
        SaveBase.save(this, SaveBase.TYPE_COLORFILTER, this, true);
        this._colorFiler = filter;
        this.stopMerge = true;
    }
    drawTexture(tex, x, y, width, height, color = 0xffffffff) {
        this._drawTextureM(tex, x, y, width, height, null, 1, null, color);
    }
    drawTextures(tex, pos, tx, ty, colors) {
        if (!tex._getSource()) {
            this.sprite && ILaya.systemTimer.callLater(this, this._repaintSprite);
            return;
        }
        var n = pos.length / 2;
        var ipos = 0;
        var bmpid = tex.bitmap.id;
        for (var i = 0; i < n; i++) {
            const color = typeof colors[i] === 'number' ? colors[i] : 0xffffffff;
            this._inner_drawTexture(tex, bmpid, pos[ipos++] + tx, pos[ipos++] + ty, 0, 0, null, null, 1.0, false, color);
        }
    }
    _drawTextureM(tex, x, y, width, height, m, alpha, uv, color) {
        var cs = this.sprite;
        if (!tex._getSource(function () {
            if (cs) {
                cs.repaint();
            }
        })) {
            return false;
        }
        return this._inner_drawTexture(tex, tex.bitmap.id, x, y, width, height, m, uv, alpha, false, color);
    }
    _drawRenderTexture(tex, x, y, width, height, m, alpha, uv, color = 0xffffffff) {
        return this._inner_drawTexture(tex, -1, x, y, width, height, m, uv, alpha, false, color);
    }
    _copyClipInfo(shaderValue) {
        let clipInfo = this._globalClipMatrix;
        var cm = shaderValue.clipMatDir;
        cm.x = clipInfo.a;
        cm.y = clipInfo.b;
        cm.z = clipInfo.c;
        cm.w = clipInfo.d;
        shaderValue.clipMatDir = cm;
        var cmp = shaderValue.clipMatPos;
        cmp.x = clipInfo.tx;
        cmp.y = clipInfo.ty;
        shaderValue.clipMatPos = cmp;
    }
    _copyClipInfoToShaderData(shaderData) {
        let clipInfo = this._globalClipMatrix;
        Vector4.TEMP.setValue(clipInfo.a, clipInfo.b, clipInfo.c, clipInfo.d);
        shaderData.setVector(ShaderDefines2D.UNIFORM_CLIPMATDIR, Vector4.TEMP);
        Vector2.TEMP.setValue(clipInfo.tx, clipInfo.ty);
        shaderData.setVector2(ShaderDefines2D.UNIFORM_CLIPMATPOS, Vector2.TEMP);
    }
    isStopMerge(submit) {
        return this.stopMerge || (submit.clipInfoID !== this._clipInfoID);
    }
    drawCallOptimize(enable) {
        this._charSubmitCache.enable(enable, this);
        return enable;
    }
    _drawToRender2D(submit) {
        let mesh = this._mesh;
        if (mesh.indexNum <= 0)
            return;
        let shaderValue = submit.shaderValue;
        let shaderdata = shaderValue.shaderData;
        switch (submit._key.blendShader) {
            case 1:
            case 3:
            case 5:
                shaderdata.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_ONE);
                shaderdata.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE);
                break;
            case 2:
                shaderdata.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_DST_COLOR);
                shaderdata.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA);
                break;
            case 6:
                shaderdata.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_ZERO);
                shaderdata.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_SRC_ALPHA);
                break;
            case 7:
                shaderdata.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_ZERO);
                shaderdata.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ZERO);
                break;
            case 9:
                shaderdata.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_SRC_ALPHA);
                shaderdata.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA);
                break;
            default:
                shaderdata.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_ONE);
                shaderdata.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA);
        }
        if (submit._colorFiler) {
            var ft = submit._colorFiler;
            shaderValue.setFilter(ft);
            Matrix4x4.TEMP.cloneByArray(ft._mat);
            shaderdata.setMatrix4x4(ShaderDefines2D.UNIFORM_COLORMAT, Matrix4x4.TEMP);
            Vector4.TEMP.setValue(ft._alpha[0], ft._alpha[1], ft._alpha[2], ft._alpha[3]);
            shaderdata.setVector(ShaderDefines2D.UNIFORM_COLORALPHA, Vector4.TEMP);
        }
        this._drawMesh(mesh, 0, mesh.vertexNum, submit._startIdx, mesh.indexNum, submit.shaderValue, submit.material);
        this.stopMerge = false;
        this._drawCount++;
    }
    _drawMesh(mesh, vboff, vertNum, iboff, indexNum, shaderValue, customMaterial) {
        if (!this._render2DManager._renderEnd) {
            this._render2DManager.render(Render2DSimple.rendercontext2D);
        }
        if (mesh.indexNum) {
            this._render2D.draw(mesh, vboff, vertNum * mesh.vertexDeclarition.vertexStride, iboff, indexNum * 2, shaderValue, customMaterial);
        }
        mesh.clearMesh();
        if (!shaderValue._needRelease) {
            shaderValue._needRelease = true;
            this._shaderValueNeedRelease.push(shaderValue);
        }
    }
    _inner_drawTexture(tex, imgid, x, y, width, height, m, uv, alpha, lastRender, color) {
        if (width <= 0 || height <= 0) {
            return false;
        }
        var preKey = this._curSubmit._key;
        uv = uv || tex._uv;
        if (preKey.submitType === SubmitBase.KEY_TRIANGLES && preKey.other === imgid) {
            var tv = this._drawTexToDrawTri_Vert;
            tv[0] = x;
            tv[1] = y;
            tv[2] = x + width, tv[3] = y, tv[4] = x + width, tv[5] = y + height, tv[6] = x, tv[7] = y + height;
            this._drawTriUseAbsMatrix = true;
            var tuv = this._tempUV;
            tuv[0] = uv[0];
            tuv[1] = uv[1];
            tuv[2] = uv[2];
            tuv[3] = uv[3];
            tuv[4] = uv[4];
            tuv[5] = uv[5];
            tuv[6] = uv[6];
            tuv[7] = uv[7];
            this.drawTriangles(tex, 0, 0, tv, tuv, this._drawTexToDrawTri_Index, m || this._curMat, alpha, null, 0xffffffff);
            this._drawTriUseAbsMatrix = false;
            return true;
        }
        var submit = this._curSubmit;
        var ops = lastRender ? this._charSubmitCache.getPos() : this._transedPoints;
        this.transformQuad(x, y, width || tex.width, height || tex.height, this._italicDeg, m || this._curMat, ops);
        if (this.drawTexAlign) {
            var round = Math.round;
            ops[0] = round(ops[0]);
            ops[1] = round(ops[1]);
            ops[2] = round(ops[2]);
            ops[3] = round(ops[3]);
            ops[4] = round(ops[4]);
            ops[5] = round(ops[5]);
            ops[6] = round(ops[6]);
            ops[7] = round(ops[7]);
            this.drawTexAlign = false;
        }
        var rgba = this._mixRGBandAlpha(color, this._alpha * alpha);
        if (lastRender) {
            this._charSubmitCache.add(this, tex, imgid, ops, uv, rgba);
            return true;
        }
        var sameKey = (imgid >= 0 && preKey.submitType === SubmitBase.KEY_DRAWTEXTURE && preKey.other === imgid) &&
            !this.isStopMerge(this._curSubmit) &&
            this._mesh.vertexNum + 4 < Context._MAXVERTNUM &&
            this._curSubmit.material == this._material;
        if (!sameKey) {
            this._drawToRender2D(this._curSubmit);
            this._mesh = this._meshQuatTex;
        }
        this._lastTex = tex;
        if (!sameKey) {
            let shaderValue = Value2D.create(RenderSpriteData.Texture2D);
            this.fillShaderValue(shaderValue);
            shaderValue.textureHost = tex;
            this._curSubmit = submit = SubmitBase.create(this, this._mesh, shaderValue);
            submit._key.other = imgid;
            this._copyClipInfo(submit.shaderValue);
            submit.clipInfoID = this._clipInfoID;
        }
        this._mesh.addQuad(ops, uv, rgba, true);
        submit._numEle += 6;
        return true;
    }
    fillShaderValue(shaderValue) {
        shaderValue.size = new Vector2(this._width, this._height);
        this._copyClipInfo(shaderValue);
    }
    clipedOff(pt) {
        if (this._clipRect.width <= 0 || this._clipRect.height <= 0)
            return true;
        return false;
    }
    transformQuad(x, y, w, h, italicDeg, m, out) {
        var xoff = 0;
        if (italicDeg != 0) {
            xoff = Math.tan(italicDeg * Math.PI / 180) * h;
        }
        var maxx = x + w;
        var maxy = y + h;
        var tx = m.tx;
        var ty = m.ty;
        var ma = m.a;
        var mb = m.b;
        var mc = m.c;
        var md = m.d;
        var a0 = x + xoff;
        var a1 = y;
        var a2 = maxx + xoff;
        var a3 = y;
        var a4 = maxx;
        var a5 = maxy;
        var a6 = x;
        var a7 = maxy;
        if (m._bTransform) {
            out[0] = a0 * ma + a1 * mc + tx;
            out[1] = a0 * mb + a1 * md + ty;
            out[2] = a2 * ma + a3 * mc + tx;
            out[3] = a2 * mb + a3 * md + ty;
            out[4] = a4 * ma + a5 * mc + tx;
            out[5] = a4 * mb + a5 * md + ty;
            out[6] = a6 * ma + a7 * mc + tx;
            out[7] = a6 * mb + a7 * md + ty;
        }
        else {
            out[0] = a0 + tx;
            out[1] = a1 + ty;
            out[2] = a2 + tx;
            out[3] = a3 + ty;
            out[4] = a4 + tx;
            out[5] = a5 + ty;
            out[6] = a6 + tx;
            out[7] = a7 + ty;
        }
    }
    breakNextMerge() {
        this.stopMerge = true;
    }
    _repaintSprite() {
        this.sprite && this.sprite.repaint();
    }
    drawTextureWithTransform(tex, x, y, width, height, transform, tx, ty, alpha, blendMode, uv, color = 0xffffffff) {
        var oldcomp;
        var curMat = this._curMat;
        if (blendMode) {
            oldcomp = this.globalCompositeOperation;
            this.globalCompositeOperation = blendMode;
        }
        if (!transform) {
            this._drawTextureM(tex, x + tx, y + ty, width, height, curMat, alpha, uv, color);
            if (blendMode) {
                this.globalCompositeOperation = oldcomp;
            }
            return;
        }
        tmpMat.a = transform.a;
        tmpMat.b = transform.b;
        tmpMat.c = transform.c;
        tmpMat.d = transform.d;
        tmpMat.tx = transform.tx + tx;
        tmpMat.ty = transform.ty + ty;
        tmpMat._bTransform = transform._bTransform;
        if (transform && curMat._bTransform) {
            Matrix.mul(tmpMat, curMat, tmpMat);
            transform = tmpMat;
            transform._bTransform = true;
        }
        else {
            tmpMat.tx += curMat.tx;
            tmpMat.ty += curMat.ty;
            transform = tmpMat;
        }
        this._drawTextureM(tex, x, y, width, height, transform, alpha, uv, color);
        if (blendMode)
            this.globalCompositeOperation = oldcomp;
    }
    drawTriangles(tex, x, y, vertices, uvs, indices, matrix, alpha, blendMode, colorNum = 0xffffffff) {
        if (alpha == null)
            alpha = 1.0;
        if (!tex._getSource()) {
            if (this.sprite) {
                ILaya.systemTimer.callLater(this, this._repaintSprite);
            }
            return;
        }
        var oldcomp = null;
        if (blendMode) {
            oldcomp = this.globalCompositeOperation;
            this.globalCompositeOperation = blendMode;
        }
        var webGLImg = tex.bitmap;
        var preKey = this._curSubmit._key;
        var sameKey = preKey.submitType === SubmitBase.KEY_TRIANGLES &&
            preKey.other === webGLImg.id &&
            preKey.blendShader == this._nBlendType &&
            this._mesh.vertexNum + vertices.length / 2 < Context._MAXVERTNUM &&
            this._curSubmit.material == this._material;
        if (!sameKey) {
            this._drawToRender2D(this._curSubmit);
            this._mesh = this._meshTex;
        }
        if (!sameKey) {
            var submit = this._curSubmit = SubmitBase.create(this, this._mesh, Value2D.create(RenderSpriteData.Texture2D));
            submit.shaderValue.textureHost = tex;
            this.fillShaderValue(submit.shaderValue);
            submit._key.submitType = SubmitBase.KEY_TRIANGLES;
            submit._key.other = webGLImg.id;
            this._copyClipInfo(submit.shaderValue);
            submit.clipInfoID = this._clipInfoID;
        }
        var rgba = this._mixRGBandAlpha(colorNum, this._alpha * alpha);
        if (!this._drawTriUseAbsMatrix) {
            if (!matrix) {
                tmpMat.a = 1;
                tmpMat.b = 0;
                tmpMat.c = 0;
                tmpMat.d = 1;
                tmpMat.tx = x;
                tmpMat.ty = y;
            }
            else {
                tmpMat.a = matrix.a;
                tmpMat.b = matrix.b;
                tmpMat.c = matrix.c;
                tmpMat.d = matrix.d;
                tmpMat.tx = matrix.tx + x;
                tmpMat.ty = matrix.ty + y;
            }
            Matrix.mul(tmpMat, this._curMat, tmpMat);
            this._mesh.addData(vertices, uvs, indices, tmpMat || this._curMat, rgba, null);
        }
        else {
            this._mesh.addData(vertices, uvs, indices, matrix, rgba, null);
        }
        this._curSubmit._numEle += indices.length;
        if (blendMode) {
            this.globalCompositeOperation = oldcomp;
        }
    }
    transform(a, b, c, d, tx, ty) {
        SaveTransform.save(this);
        Matrix.mul(Matrix.TEMP.setTo(a, b, c, d, tx, ty), this._curMat, this._curMat);
        this._curMat._checkTransform();
    }
    rotate(angle) {
        SaveTransform.save(this);
        this._curMat.rotateEx(angle);
    }
    scale(scaleX, scaleY) {
        SaveTransform.save(this);
        this._curMat.scaleEx(scaleX, scaleY);
    }
    clipRect(x, y, width, height, escape) {
        SaveClipRect.save(this);
        if (this._clipRect == Context.MAXCLIPRECT) {
            this._clipRect = new Rectangle(x, y, width, height);
        }
        else {
            this._clipRect.width = width;
            this._clipRect.height = height;
            this._clipRect.x = x;
            this._clipRect.y = y;
        }
        this._clipID_Gen++;
        this._clipID_Gen %= 10000;
        this._clipInfoID = this._clipID_Gen;
        if (escape) {
            defaultClipMatrix.copyTo(this._globalClipMatrix);
            return;
        }
        var cm = this._globalClipMatrix;
        var minx = cm.tx;
        var miny = cm.ty;
        var maxx = minx + cm.a;
        var maxy = miny + cm.d;
        if (this._clipRect.width >= Const.MAX_CLIP_SIZE) {
            cm.a = cm.d = Const.MAX_CLIP_SIZE;
            cm.b = cm.c = cm.tx = cm.ty = 0;
        }
        else {
            if (this._curMat._bTransform) {
                cm.tx = this._clipRect.x * this._curMat.a + this._clipRect.y * this._curMat.c + this._curMat.tx;
                cm.ty = this._clipRect.x * this._curMat.b + this._clipRect.y * this._curMat.d + this._curMat.ty;
                cm.a = this._clipRect.width * this._curMat.a;
                cm.b = this._clipRect.width * this._curMat.b;
                cm.c = this._clipRect.height * this._curMat.c;
                cm.d = this._clipRect.height * this._curMat.d;
            }
            else {
                cm.tx = this._clipRect.x + this._curMat.tx;
                cm.ty = this._clipRect.y + this._curMat.ty;
                cm.a = this._clipRect.width;
                cm.b = cm.c = 0;
                cm.d = this._clipRect.height;
            }
        }
        if (cm.a > 0 && cm.d > 0) {
            var cmaxx = cm.tx + cm.a;
            var cmaxy = cm.ty + cm.d;
            if (cmaxx <= minx || cmaxy <= miny || cm.tx >= maxx || cm.ty >= maxy) {
                cm.a = -0.1;
                cm.d = -0.1;
            }
            else {
                if (cm.tx < minx) {
                    cm.a -= (minx - cm.tx);
                    cm.tx = minx;
                }
                if (cmaxx > maxx) {
                    cm.a -= (cmaxx - maxx);
                }
                if (cm.ty < miny) {
                    cm.d -= (miny - cm.ty);
                    cm.ty = miny;
                }
                if (cmaxy > maxy) {
                    cm.d -= (cmaxy - maxy);
                }
                if (cm.a <= 0)
                    cm.a = -0.1;
                if (cm.d <= 0)
                    cm.d = -0.1;
            }
        }
    }
    startRender() {
        for (let sv of this._shaderValueNeedRelease) {
            sv.release();
            sv._needRelease = false;
        }
        this._shaderValueNeedRelease.length = 0;
        this._render2D.renderStart(this._clear, this._clearColor);
        this.clear();
    }
    endRender() {
        this.flush();
        if (!this._render2DManager._renderEnd) {
            this._render2DManager.render(Render2DSimple.rendercontext2D);
        }
        this._render2D.renderEnd();
        this._curSubmit = SubmitBase.RENDERBASE;
    }
    drawLeftData() {
        if (!this._render2DManager._renderEnd) {
            this._render2DManager.render(Render2DSimple.rendercontext2D);
        }
        this._drawToRender2D(this._curSubmit);
    }
    flush() {
        this.drawLeftData();
        this._clipID_Gen = 0;
        this._path && this._path.reset();
        this._curSubmit = SubmitBase.RENDERBASE;
        this._flushCnt++;
        if (this._flushCnt % 60 == 0 && this.isMain) {
            if (TextRender.textRenderInst) {
                TextRender.textRenderInst.GC();
            }
        }
    }
    beginPath(convex = false) {
        this._getPath().beginPath(convex);
    }
    closePath() {
        this._path.closePath();
    }
    addPath(points, close, convex, dx, dy) {
        let sz = points.length;
        for (let i = 0; i < sz - 1; i += 2) {
            points[i] += dx;
            points[i + 1] += dy;
        }
        if (close && sz > 5 && (points[sz - 2] != points[0] || points[sz - 1] != points[1])) {
            points.push(points[0], points[1]);
        }
        this._getPath().push(points, convex);
    }
    fill() {
        var m = this._curMat;
        var tPath = this._getPath();
        var submit = this._curSubmit;
        var sameKey = (submit._key.submitType === SubmitBase.KEY_VG && submit._key.blendShader === this._nBlendType) &&
            !this.isStopMerge(submit) &&
            this._curSubmit.material == this._material;
        if (!sameKey) {
            this._drawToRender2D(submit);
            this._mesh = this._meshVG;
            this._curSubmit = this.addVGSubmit(this._mesh);
            this.fillShaderValue(this._curSubmit.shaderValue);
        }
        var rgba = this.mixRGBandAlpha(this._fillStyle._color.numColor);
        var curEleNum = 0;
        var idx;
        for (var i = 0, sz = tPath.paths.length; i < sz; i++) {
            var p = tPath.paths[i];
            var vertNum = p.path.length / 2;
            if (vertNum < 3 || (vertNum == 3 && !p.convex))
                continue;
            var cpath = p.path.concat();
            var pi = 0;
            var xp, yp;
            var _x, _y;
            if (m._bTransform) {
                for (pi = 0; pi < vertNum; pi++) {
                    xp = pi << 1;
                    yp = xp + 1;
                    _x = cpath[xp];
                    _y = cpath[yp];
                    cpath[xp] = m.a * _x + m.c * _y + m.tx;
                    cpath[yp] = m.b * _x + m.d * _y + m.ty;
                }
            }
            else {
                for (pi = 0; pi < vertNum; pi++) {
                    xp = pi << 1;
                    yp = xp + 1;
                    _x = cpath[xp];
                    _y = cpath[yp];
                    cpath[xp] = _x + m.tx;
                    cpath[yp] = _y + m.ty;
                }
            }
            if (this._mesh.vertexNum + vertNum > Context._MAXVERTNUM) {
                this._curSubmit._numEle += curEleNum;
                curEleNum = 0;
                this._mesh = new MeshVG();
                this._curSubmit = this.addVGSubmit(this._mesh);
                this.fillShaderValue(this._curSubmit.shaderValue);
            }
            var curvert = this._mesh.vertexNum;
            if (p.convex) {
                var faceNum = vertNum - 2;
                idx = new Array(faceNum * 3);
                var idxpos = 0;
                for (var fi = 0; fi < faceNum; fi++) {
                    idx[idxpos++] = curvert;
                    idx[idxpos++] = fi + 1 + curvert;
                    idx[idxpos++] = fi + 2 + curvert;
                }
            }
            else {
                idx = Earcut.earcut(cpath, null, 2);
                if (curvert > 0) {
                    for (var ii = 0; ii < idx.length; ii++) {
                        idx[ii] += curvert;
                    }
                }
            }
            this._mesh.addVertAndIBToMesh(cpath, rgba, idx);
            curEleNum += idx.length;
        }
        this._curSubmit._numEle += curEleNum;
    }
    addVGSubmit(mesh) {
        var submit = SubmitBase.create(this, mesh, Value2D.create(RenderSpriteData.Primitive));
        this.fillShaderValue(submit.shaderValue);
        submit._key.submitType = SubmitBase.KEY_VG;
        this._copyClipInfo(submit.shaderValue);
        submit.clipInfoID = this._clipInfoID;
        return submit;
    }
    stroke() {
        if (this.lineWidth <= 0)
            return;
        var rgba = this.mixRGBandAlpha(this.strokeStyle._color.numColor);
        var tPath = this._getPath();
        var submit = this._curSubmit;
        var sameKey = (submit._key.submitType === SubmitBase.KEY_VG && submit._key.blendShader === this._nBlendType) &&
            !this.isStopMerge(submit) &&
            this._curSubmit.material == this._material;
        if (!sameKey) {
            this._drawToRender2D(this._curSubmit);
            this._mesh = this._meshVG;
            this._curSubmit = this.addVGSubmit(this._mesh);
            this.fillShaderValue(this._curSubmit.shaderValue);
        }
        var curEleNum = 0;
        for (var i = 0, sz = tPath.paths.length; i < sz; i++) {
            var p = tPath.paths[i];
            if (p.path.length <= 0)
                continue;
            var idx = [];
            var vertex = [];
            var maxVertexNum = p.path.length * 2;
            if (maxVertexNum < 2)
                continue;
            if (this._mesh.vertexNum + maxVertexNum > Context._MAXVERTNUM) {
                this._curSubmit._numEle += curEleNum;
                curEleNum = 0;
                this._drawToRender2D(this._curSubmit);
                this._mesh = new MeshVG();
                this._curSubmit = this.addVGSubmit(this._mesh);
                this.fillShaderValue(this._curSubmit.shaderValue);
            }
            BasePoly.createLine2(p.path, idx, this.lineWidth, this._mesh.vertexNum, vertex, p.loop);
            var ptnum = vertex.length / 2;
            var m = this._curMat;
            var pi = 0;
            var xp, yp;
            var _x, _y;
            if (m._bTransform) {
                for (pi = 0; pi < ptnum; pi++) {
                    xp = pi << 1;
                    yp = xp + 1;
                    _x = vertex[xp];
                    _y = vertex[yp];
                    vertex[xp] = m.a * _x + m.c * _y + m.tx;
                    vertex[yp] = m.b * _x + m.d * _y + m.ty;
                }
            }
            else {
                for (pi = 0; pi < ptnum; pi++) {
                    xp = pi << 1;
                    yp = xp + 1;
                    _x = vertex[xp];
                    _y = vertex[yp];
                    vertex[xp] = _x + m.tx;
                    vertex[yp] = _y + m.ty;
                }
            }
            this._mesh.addVertAndIBToMesh(vertex, rgba, idx);
            curEleNum += idx.length;
        }
        this._curSubmit._numEle += curEleNum;
    }
    moveTo(x, y) {
        var tPath = this._getPath();
        tPath.newPath();
        tPath._lastOriX = x;
        tPath._lastOriY = y;
        tPath.addPoint(x, y);
    }
    lineTo(x, y) {
        var tPath = this._getPath();
        if (Math.abs(x - tPath._lastOriX) < 1e-3 && Math.abs(y - tPath._lastOriY) < 1e-3)
            return;
        tPath._lastOriX = x;
        tPath._lastOriY = y;
        tPath.addPoint(x, y);
    }
    arcTo(x1, y1, x2, y2, r) {
        var i = 0;
        var x = 0, y = 0;
        var dx = this._path._lastOriX - x1;
        var dy = this._path._lastOriY - y1;
        var len1 = Math.sqrt(dx * dx + dy * dy);
        if (len1 <= 0.000001) {
            return;
        }
        var ndx = dx / len1;
        var ndy = dy / len1;
        var dx2 = x2 - x1;
        var dy2 = y2 - y1;
        var len22 = dx2 * dx2 + dy2 * dy2;
        var len2 = Math.sqrt(len22);
        if (len2 <= 0.000001) {
            return;
        }
        var ndx2 = dx2 / len2;
        var ndy2 = dy2 / len2;
        var odx = ndx + ndx2;
        var ody = ndy + ndy2;
        var olen = Math.sqrt(odx * odx + ody * ody);
        if (olen <= 0.000001) {
            return;
        }
        var nOdx = odx / olen;
        var nOdy = ody / olen;
        var alpha = Math.acos(nOdx * ndx + nOdy * ndy);
        var halfAng = Math.PI / 2 - alpha;
        len1 = r * Math.tan(halfAng);
        var ptx1 = len1 * ndx + x1;
        var pty1 = len1 * ndy + y1;
        var orilen = Math.sqrt(len1 * len1 + r * r);
        var orix = x1 + nOdx * orilen;
        var oriy = y1 + nOdy * orilen;
        var ptx2 = len1 * ndx2 + x1;
        var pty2 = len1 * ndy2 + y1;
        var dir = ndx * ndy2 - ndy * ndx2;
        var fChgAng = 0;
        var sinx = 0.0;
        var cosx = 0.0;
        if (dir >= 0) {
            fChgAng = halfAng * 2;
            var fda = fChgAng / Context.SEGNUM;
            sinx = Math.sin(fda);
            cosx = Math.cos(fda);
        }
        else {
            fChgAng = -halfAng * 2;
            fda = fChgAng / Context.SEGNUM;
            sinx = Math.sin(fda);
            cosx = Math.cos(fda);
        }
        var lastx = this._path._lastOriX, lasty = this._path._lastOriY;
        var _x1 = ptx1, _y1 = pty1;
        if (Math.abs(_x1 - this._path._lastOriX) > 0.1 || Math.abs(_y1 - this._path._lastOriY) > 0.1) {
            x = _x1;
            y = _y1;
            lastx = _x1;
            lasty = _y1;
            this._path._lastOriX = x;
            this._path._lastOriY = y;
            this._path.addPoint(x, y);
        }
        var cvx = ptx1 - orix;
        var cvy = pty1 - oriy;
        var tx = 0.0;
        var ty = 0.0;
        for (i = 0; i < Context.SEGNUM; i++) {
            var cx = cvx * cosx + cvy * sinx;
            var cy = -cvx * sinx + cvy * cosx;
            x = cx + orix;
            y = cy + oriy;
            if (Math.abs(lastx - x) > 0.1 || Math.abs(lasty - y) > 0.1) {
                this._path._lastOriX = x;
                this._path._lastOriY = y;
                this._path.addPoint(x, y);
                lastx = x;
                lasty = y;
            }
            cvx = cx;
            cvy = cy;
        }
    }
    arc(cx, cy, rx, ry, startAngle, endAngle, counterclockwise = false, b = true, minNum = 20) {
        if (startAngle > endAngle) {
            [startAngle, endAngle] = [endAngle, startAngle];
        }
        let da = endAngle - startAngle;
        if (!counterclockwise) {
            if (Math.abs(da) >= Math.PI * 2) {
                da = Math.PI * 2;
            }
            else {
                while (da < 0.0) {
                    da += Math.PI * 2;
                }
            }
        }
        else {
            if (Math.abs(da) >= Math.PI * 2) {
                da = -Math.PI * 2;
            }
            else {
                while (da > 0.0) {
                    da -= Math.PI * 2;
                }
            }
        }
        var sx = this.getMatScaleX();
        var sy = this.getMatScaleY();
        var sr = rx * (sx > sy ? sx : sy);
        var cl = 2 * Math.PI * sr;
        let ndivs = (Math.max(cl / 5, minNum)) | 0;
        let stepAng = Math.PI * 2 / ndivs;
        var tPath = this._getPath();
        let x = cx + Math.cos(startAngle) * rx;
        let y = cy + Math.sin(startAngle) * ry;
        if (x != this._path._lastOriX || y != this._path._lastOriY) {
            tPath.addPoint(x, y);
        }
        let curAng = Math.ceil(startAngle / stepAng) * stepAng;
        while (endAngle - curAng >= stepAng) {
            x = cx + Math.cos(curAng) * rx;
            y = cy + Math.sin(curAng) * ry;
            tPath.addPoint(x, y);
            curAng += stepAng;
        }
        x = cx + Math.cos(endAngle) * rx;
        y = cy + Math.sin(endAngle) * ry;
        if (x != this._path._lastOriX || y != this._path._lastOriY) {
            tPath.addPoint(x, y);
        }
    }
    quadraticCurveTo(cpx, cpy, x, y) {
        var tArray = Bezier.getPoints([this._path._lastOriX, this._path._lastOriY, cpx, cpy, x, y], 30, 2);
        for (var i = 0, n = tArray.length / 2; i < n; i++) {
            this.lineTo(tArray[i * 2], tArray[i * 2 + 1]);
        }
        this.lineTo(x, y);
    }
    mixRGBandAlpha(color) {
        return this._mixRGBandAlpha(color, this._alpha);
    }
    _mixRGBandAlpha(color, alpha) {
        if (alpha >= 1) {
            return color;
        }
        var a = ((color & 0xff000000) >>> 24);
        if (a != 0) {
            a *= alpha;
        }
        else {
            a = alpha * 255;
        }
        return (color & 0x00ffffff) | (a << 24);
    }
    strokeRect(x, y, width, height, parameterLineWidth) {
        var tW = parameterLineWidth * 0.5;
        if (this.lineWidth > 0) {
            var rgba = this.mixRGBandAlpha(this.strokeStyle._color.numColor);
            var hw = this.lineWidth / 2;
            this._fillRect(x - hw, y - hw, width + this.lineWidth, this.lineWidth, rgba);
            this._fillRect(x - hw, y - hw + height, width + this.lineWidth, this.lineWidth, rgba);
            this._fillRect(x - hw, y + hw, this.lineWidth, height - this.lineWidth, rgba);
            this._fillRect(x - hw + width, y + hw, this.lineWidth, height - this.lineWidth, rgba);
        }
    }
    drawParticle(x, y, pt) {
    }
    _getPath() {
        return this._path || (this._path = new Path());
    }
    get canvas() {
        return this._canvas;
    }
    _fillTexture_h(tex, imgid, uv, oriw, orih, x, y, w, color) {
        if (oriw <= 0)
            return;
        var stx = x;
        var num = Math.floor(w / oriw);
        var left = w % oriw;
        for (var i = 0; i < num; i++) {
            this._inner_drawTexture(tex, imgid, stx, y, oriw, orih, this._curMat, uv, 1, false, color);
            stx += oriw;
        }
        if (left > 0) {
            var du = uv[2] - uv[0];
            var uvr = uv[0] + du * (left / oriw);
            var tuv = tmpuv1;
            tuv[0] = uv[0];
            tuv[1] = uv[1];
            tuv[2] = uvr;
            tuv[3] = uv[3];
            tuv[4] = uvr;
            tuv[5] = uv[5];
            tuv[6] = uv[6];
            tuv[7] = uv[7];
            this._inner_drawTexture(tex, imgid, stx, y, left, orih, this._curMat, tuv, 1, false, color);
        }
    }
    _fillTexture_v(tex, imgid, uv, oriw, orih, x, y, h, color) {
        if (orih <= 0)
            return;
        var sty = y;
        var num = Math.floor(h / orih);
        var left = h % orih;
        for (var i = 0; i < num; i++) {
            this._inner_drawTexture(tex, imgid, x, sty, oriw, orih, this._curMat, uv, 1, false, color);
            sty += orih;
        }
        if (left > 0) {
            var dv = uv[7] - uv[1];
            var uvb = uv[1] + dv * (left / orih);
            var tuv = tmpuv1;
            tuv[0] = uv[0];
            tuv[1] = uv[1];
            tuv[2] = uv[2];
            tuv[3] = uv[3];
            tuv[4] = uv[4];
            tuv[5] = uvb;
            tuv[6] = uv[6];
            tuv[7] = uvb;
            this._inner_drawTexture(tex, imgid, x, sty, oriw, left, this._curMat, tuv, 1, false, color);
        }
    }
    _gridCut(left, right, width, out) {
        let c = (left + right) / 2;
        let d = (left + right - width) / 2;
        let ll = 0, lr = left;
        let rl = left, rr = left + right;
        let cl = c - d, cr = c + d;
        let hl = Math.max(ll, cl);
        let hr = Math.min(lr, cr);
        if (hr > hl) {
            left -= (hr - hl);
        }
        hl = Math.max(rl, cl);
        hr = Math.min(rr, cr);
        if (hr > hl) {
            right -= (hr - hl);
        }
        out.x = left;
        out.y = right;
    }
    drawTextureWithSizeGrid(tex, tx, ty, width, height, sizeGrid, gx, gy, color) {
        if (!tex._getSource())
            return;
        tx += gx;
        ty += gy;
        var uv = tex.uv, w = tex.bitmap.width, h = tex.bitmap.height;
        var top = sizeGrid[0];
        var left = sizeGrid[3];
        var right = sizeGrid[1];
        var bottom = sizeGrid[2];
        var repeat = sizeGrid[4];
        if (width == tex.width) {
            left = right = 0;
        }
        if (height == tex.height) {
            top = bottom = 0;
        }
        var imgid = tex.bitmap.id;
        var mat = this._curMat;
        var tuv = this._tempUV;
        let hasmidx = true;
        if (left + right > width) {
            hasmidx = false;
            this._gridCut(left, right, width, _clipResult);
            left = _clipResult.x;
            right = _clipResult.y;
        }
        let hasmidy = true;
        if (top + bottom > height) {
            hasmidy = false;
            this._gridCut(top, bottom, height, _clipResult);
            top = _clipResult.x;
            bottom = _clipResult.y;
        }
        var d_top = top / h;
        var d_left = left / w;
        var d_right = right / w;
        var d_bottom = bottom / h;
        var uvl = uv[0];
        var uvt = uv[1];
        var uvr = uv[4];
        var uvb = uv[5];
        var uvl_ = uvl;
        var uvt_ = uvt;
        var uvr_ = uvr;
        var uvb_ = uvb;
        if (left && top) {
            uvr_ = uvl + d_left;
            uvb_ = uvt + d_top;
            tuv[0] = uvl, tuv[1] = uvt, tuv[2] = uvr_, tuv[3] = uvt,
                tuv[4] = uvr_, tuv[5] = uvb_, tuv[6] = uvl, tuv[7] = uvb_;
            this._inner_drawTexture(tex, imgid, tx, ty, left, top, mat, tuv, 1, false, color);
        }
        if (right && top) {
            uvl_ = uvr - d_right;
            uvt_ = uvt;
            uvr_ = uvr;
            uvb_ = uvt + d_top;
            tuv[0] = uvl_, tuv[1] = uvt_, tuv[2] = uvr_, tuv[3] = uvt_,
                tuv[4] = uvr_, tuv[5] = uvb_, tuv[6] = uvl_, tuv[7] = uvb_;
            this._inner_drawTexture(tex, imgid, width - right + tx, 0 + ty, right, top, mat, tuv, 1, false, color);
        }
        if (left && bottom) {
            uvl_ = uvl;
            uvt_ = uvb - d_bottom;
            uvr_ = uvl + d_left;
            uvb_ = uvb;
            tuv[0] = uvl_, tuv[1] = uvt_, tuv[2] = uvr_, tuv[3] = uvt_,
                tuv[4] = uvr_, tuv[5] = uvb_, tuv[6] = uvl_, tuv[7] = uvb_;
            this._inner_drawTexture(tex, imgid, 0 + tx, height - bottom + ty, left, bottom, mat, tuv, 1, false, color);
        }
        if (right && bottom) {
            uvl_ = uvr - d_right;
            uvt_ = uvb - d_bottom;
            uvr_ = uvr;
            uvb_ = uvb;
            tuv[0] = uvl_, tuv[1] = uvt_, tuv[2] = uvr_, tuv[3] = uvt_,
                tuv[4] = uvr_, tuv[5] = uvb_, tuv[6] = uvl_, tuv[7] = uvb_;
            this._inner_drawTexture(tex, imgid, width - right + tx, height - bottom + ty, right, bottom, mat, tuv, 1, false, color);
        }
        if (top && hasmidx) {
            uvl_ = uvl + d_left;
            uvt_ = uvt;
            uvr_ = uvr - d_right;
            uvb_ = uvt + d_top;
            tuv[0] = uvl_, tuv[1] = uvt_, tuv[2] = uvr_, tuv[3] = uvt_,
                tuv[4] = uvr_, tuv[5] = uvb_, tuv[6] = uvl_, tuv[7] = uvb_;
            if (repeat) {
                this._fillTexture_h(tex, imgid, tuv, tex.width - left - right, top, left + tx, ty, width - left - right, color);
            }
            else {
                this._inner_drawTexture(tex, imgid, left + tx, ty, width - left - right, top, mat, tuv, 1, false, color);
            }
        }
        if (bottom && hasmidx) {
            uvl_ = uvl + d_left;
            uvt_ = uvb - d_bottom;
            uvr_ = uvr - d_right;
            uvb_ = uvb;
            tuv[0] = uvl_, tuv[1] = uvt_, tuv[2] = uvr_, tuv[3] = uvt_,
                tuv[4] = uvr_, tuv[5] = uvb_, tuv[6] = uvl_, tuv[7] = uvb_;
            if (repeat) {
                this._fillTexture_h(tex, imgid, tuv, tex.width - left - right, bottom, left + tx, height - bottom + ty, width - left - right, color);
            }
            else {
                this._inner_drawTexture(tex, imgid, left + tx, height - bottom + ty, width - left - right, bottom, mat, tuv, 1, false, color);
            }
        }
        if (left && hasmidy) {
            uvl_ = uvl;
            uvt_ = uvt + d_top;
            uvr_ = uvl + d_left;
            uvb_ = uvb - d_bottom;
            tuv[0] = uvl_, tuv[1] = uvt_, tuv[2] = uvr_, tuv[3] = uvt_,
                tuv[4] = uvr_, tuv[5] = uvb_, tuv[6] = uvl_, tuv[7] = uvb_;
            if (repeat) {
                this._fillTexture_v(tex, imgid, tuv, left, tex.height - top - bottom, tx, top + ty, height - top - bottom, color);
            }
            else {
                this._inner_drawTexture(tex, imgid, tx, top + ty, left, height - top - bottom, mat, tuv, 1, false, color);
            }
        }
        if (right && hasmidy) {
            uvl_ = uvr - d_right;
            uvt_ = uvt + d_top;
            uvr_ = uvr;
            uvb_ = uvb - d_bottom;
            tuv[0] = uvl_, tuv[1] = uvt_, tuv[2] = uvr_, tuv[3] = uvt_,
                tuv[4] = uvr_, tuv[5] = uvb_, tuv[6] = uvl_, tuv[7] = uvb_;
            if (repeat) {
                this._fillTexture_v(tex, imgid, tuv, right, tex.height - top - bottom, width - right + tx, top + ty, height - top - bottom, color);
            }
            else {
                this._inner_drawTexture(tex, imgid, width - right + tx, top + ty, right, height - top - bottom, mat, tuv, 1, false, color);
            }
        }
        if (hasmidx && hasmidy) {
            uvl_ = uvl + d_left;
            uvt_ = uvt + d_top;
            uvr_ = uvr - d_right;
            uvb_ = uvb - d_bottom;
            tuv[0] = uvl_, tuv[1] = uvt_, tuv[2] = uvr_, tuv[3] = uvt_,
                tuv[4] = uvr_, tuv[5] = uvb_, tuv[6] = uvl_, tuv[7] = uvb_;
            if (repeat) {
                var tuvr = Context.tmpUVRect;
                tuvr[0] = uvl_;
                tuvr[1] = uvt_;
                tuvr[2] = uvr_ - uvl_;
                tuvr[3] = uvb_ - uvt_;
                this._fillTexture(tex, tex.width - left - right, tex.height - top - bottom, tuvr, left + tx, top + ty, width - left - right, height - top - bottom, 'repeat', 0, 0, color);
            }
            else {
                this._inner_drawTexture(tex, imgid, left + tx, top + ty, width - left - right, height - top - bottom, mat, tuv, 1, false, color);
            }
        }
    }
}
Context._MAXVERTNUM = 65535;
Context.MAXCLIPRECT = null;
Context.SEGNUM = 32;
Context._contextcount = 0;
Context._textRender = null;
Context.tmpUVRect = [0, 0, 0, 0];
class ContextParams {
    constructor() {
        this.lineWidth = 1;
    }
    clear() {
        this.lineWidth = 1;
        this.textAlign = this.textBaseline = null;
    }
    make() {
        return this === ContextParams.DEFAULT ? new ContextParams() : this;
    }
}
